import { CardContent } from '@mui/material';
import { FC } from 'react';

interface Props {
  className?: string;
  children: React.ReactNode;
}

export const QcsCardContent: FC<Props> = ({ className, children }) => {
  return <CardContent className={className}>{children}</CardContent>;
};
